import React from "react";
import { Star } from "lucide-react";

export const TRUSTPILOT_RATING = "Excellent";
export const TRUSTPILOT_SCORE = 4.3; // update if the score changes
const STARS = Math.round(TRUSTPILOT_SCORE * 2) / 2; // nearest half-star, Trustpilot-style

// Trustpilot-style star row: green (#00b67a) fill over light-grey tiles, white star on each
const TrustStars = ({ value }) => (
  <span className="inline-flex items-center gap-[2px]" aria-hidden="true">
    {[0, 1, 2, 3, 4].map((i) => {
      const fill = Math.max(0, Math.min(1, value - i));
      return (
        <span
          key={i}
          className="relative inline-flex h-[15px] w-[15px] items-center justify-center overflow-hidden rounded-[2px] bg-[#dcdce6]"
        >
          <span
            className="absolute inset-y-0 left-0 bg-[#00b67a]"
            style={{ width: `${fill * 100}%` }}
          />
          <Star size={10} strokeWidth={0} className="relative fill-white text-white" />
        </span>
      );
    })}
  </span>
);

// Non-clickable trust mark: single green star + "Trustpilot" + rating word + star row
export const TrustpilotBadge = ({ className = "" }) => (
  <span
    className={`inline-flex items-center gap-1.5 leading-none ${className}`}
    data-testid="trustpilot-badge"
    aria-label={`Trustpilot rating: ${TRUSTPILOT_RATING}, ${TRUSTPILOT_SCORE} out of 5`}
  >
    <span className="inline-flex h-[15px] w-[15px] items-center justify-center rounded-[3px] bg-[#00b67a]">
      <Star size={10} strokeWidth={0} className="fill-white text-white" />
    </span>
    <span className="text-white/80 text-sm tracking-tight">Trustpilot</span>
    <span className="font-bold uppercase tracking-wide text-[12px] text-[#00b67a]">
      {TRUSTPILOT_RATING}
    </span>
    <TrustStars value={STARS} />
  </span>
);

export default TrustpilotBadge;
